import React from 'react'
import FAQExpandingPanel from './calculators-layout/FAQExpandingPanel';

class CalculatorsFAQ extends React.Component {
  
  render() {
    return (
      <React.Fragment>
        {
          this.props.faqs.map(faq => (
            <FAQExpandingPanel title={faq.question} key={faq.question}>
              <div>{faq.answer}</div>
            </FAQExpandingPanel>
          ))
        }
      </React.Fragment>
    )
  }
}

export default CalculatorsFAQ;
